import React, {
  useState,
  Fragment,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { ToastContainer } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import swal from "sweetalert";

import useFullPageLoader from "../../../../hooks/useFullPageLoader";

import PageTitle from "../../../layouts/PageTitle";
import Table from "../../../components/table/ReactTable/Table";

import { ColumnFilter } from "../../../components/table/ReactTable/ColumnFilter";
import {
  restApi,
  restApi_PD,
} from "../../../../services/wooCommerceRestApi/restApi";
import Toastr from "../../../components/common/Toastr";
import { subCategoryActions, masterActions } from "../../../../_store";
import generatePDF from "../../../components/export/generatePDF";
import generateXlsx from "../../../components/export/generateXlsx";
import emptyImage from "../../../../images/no-image-png-2.png";
import CommonService from "../../../../services/Common/CommonService";

const {
  REACT_APP_API_IMAGE_URL,
  REACT_APP_WORD_PRESS_REST_API,
  REACT_APP_WORD_PRESS_USER_Name,
  REACT_APP_WORD_PRESS_PASSWORD,
  REACT_APP_PD_WORD_PRESS_USER_Name,
  REACT_APP_PD_WORD_PRESS_PASSWORD,
  REACT_APP_PD_WORD_PRESS_REST_API,
} = process.env;

const SubCategories = () => {
  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // #region Reducers ------------------  Reducers --------------------------------

  const currentUser = useSelector((x) => x.auth.user);
  const subCategoryList = useSelector((x) => x.subCategory.subCategoryList);
  const subCategory = useSelector((x) => x.subCategory.subCategory);
  const subCategoryResponse = useSelector(
    (x) => x.subCategory.subCategoryResponse
  );
  const deleteSubCategoryResponse = useSelector(
    (x) => x.subCategory.deleteSubCategoryResponse
  );
  const categoryDrpList = useSelector((x) => x.master.categoryDrpList);
  const isLoading = useSelector((x) => x.subCategory.isLoading);

  // #endregion Reducers ------------------  Reducers End --------------------------------

  let styles = {
    control: (styles) => ({ ...styles, border: "1px solid red" }),
  };

  const SubCategories_COLUMNS = [
    {
      Header: "Category Name",
      Footer: "Category Name",
      accessor: "CategoryName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: " Sub Category Name",
      Footer: " Sub Category Name",
      accessor: "SubCategoryName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Description",
      Footer: "Description",
      accessor: "Description",
      justify: "left",
      Cell: ({ value }) => {
        return (
          <>
            <div style={{ maxWidth: 336 }}> {value}</div>
          </>
        );
      },
      Filter: ColumnFilter,
    },
    {
      Header: "Created by",
      Footer: "Created by",
      accessor: "CreatedByName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Created Date",
      Footer: "Created Date",
      accessor: "CreatedDateString",
      justify: "left",
      fieldType: "Date",
      // Cell: ({ value }) => { return format(new Date(value), 'MM/dd/yyyy') },
      Filter: ColumnFilter,
    },
    {
      Header: "Website",
      Footer: "Website",
      accessor: "Woocommerce",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Status",
      Footer: "Status",
      accessor: "StatusName",
      justify: "center",
      Cell: ({ value }) => {
        return (
          <>
            <Badge variant="primary light badge-lg"> {value}</Badge>
          </>
        );
      },
      Filter: ColumnFilter,
    },
    {
      Header: "",
      Footer: "",
      accessor: "SubCategoryID",
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <>
            <div className="d-flex">
              <Link
                onClick={() => handleEditClick(row.original)}
                className="btn btn-primary shadow btn-xs sharp me-1"
                title="Edit"
              >
                <i className="fas fa-pen"></i>
              </Link>
              <Link
                onClick={() => handleDeleteClick(row.original)}
                className="btn btn-danger shadow btn-xs sharp"
                title="Delete"
              >
                <i className="fa fa-trash"></i>
              </Link>
            </div>
          </>
        );
      },
    },
  ];

  const refImageFormData = useRef("");

  const generateColumns = [
    {
      header: " Category Name",
      dataKey: "CategoryName",
    },
    {
      header: " Sub Category Name",
      dataKey: "SubCategoryName",
    },
    {
      header: "Description",
      dataKey: "Description",
    },
    {
      header: "Created By",
      dataKey: "CreatedByName",
    },
    {
      header: "Created Date",
      dataKey: "CreatedDateString",
    },

    {
      header: "Website",
      dataKey: "Woocommerce",
    },
    {
      header: "Status",
      dataKey: "StatusName",
    },
  ];

  const columns = useMemo(() => SubCategories_COLUMNS, []);
  const inputRef = useRef(null);
  const [isOpenModal, setOpenModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [finalTableData, setFinalTableData] = useState([]);

  const handleTableDataUpdate = useCallback((data) => {
    setFinalTableData(data);
  }, []);

  //Add data
  const [addFormData, setAddFormData] = useState({
    SubCategoryID: 0,
    WCSubCategoryID: 0,
    PDWCSubCategoryID: 0,
    CategoryID: 0,
    SubCategoryName: "",
    Description: "",
    ImageFile: "",
    ImageFilePath: "",
    ImageBase64: "",
    Status: 1,
    WCImageURL: "",
    PDWCImageURL: "",
    IsGemar: false,
    IsPartyDeco: false,
    CategoryOption: null,
    CreatedBy: currentUser.Id,
  });

  const newFormData = { ...addFormData };

  const [wordPressData, setWordPressData] = useState({
    source_url: "",
  });

  useEffect(() => {
    showLoader();
    let CategoryID = 0;
    let Status = 1;
    dispatch(masterActions.GetCategoryDrpList({ CategoryID, Status }));
    dispatch(subCategoryActions.getSubCategoryAll());
  }, [dispatch]);

  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);

  // handle Change function
  const handleChange = (event) => {
    event.preventDefault();
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    if (fieldValue && fieldValue.trim()) {
      newFormData[fieldName] = fieldValue;
    } else {
      newFormData[fieldName] = fieldValue.trim();
    }

    setAddFormData(newFormData);
  };

  // handle Dropdown Change function
  const handleDrpChange = (event, title) => {
    newFormData[title] = event.value && parseInt(event.value);
    if (title === "CategoryID") {
      newFormData.CategoryOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    }
    setAddFormData(newFormData);
  };

  // handle Check Box Click function
  const handleCkBoxChange = (event, title) => {
    let hasChecked = event.target.checked === true ? 1 : 2;
    if (
      !event.target.checked &&
      newFormData.SubCategoryID &&
      newFormData.SubCategoryID > 0
    ) {
      showLoader();

      let Param = { DeleteID: newFormData.SubCategoryID, DeleteType: 3 };
      CommonService.CheckMappedItem(Param).then((res) => {
        if (res.data === 1) {
          newFormData[title] = hasChecked;
          setAddFormData(newFormData);
          hideLoader();
        } else {
          Toastr("This SubCatgory is already mapped", "warning");
          hideLoader();
        }
      });
    } else {
      newFormData[title] = hasChecked;
      setAddFormData(newFormData);
    }
  };

  const handleChkBoxChangeWooCom = (event) => {
    const { name, checked } = event.target;

    setAddFormData((newFormData) => ({
      ...newFormData,
      [name]: checked ? true : false,
    }));
  };

  const handlePoupClick = () => {
    newFormData.SubCategoryID =
      newFormData.WCSubCategoryID =
      newFormData.CategoryID =
        0;

    newFormData.SubCategoryName =
      newFormData.Description =
      newFormData.ImageFile =
      newFormData.ImageFilePath =
      newFormData.ImageBase64 =
      newFormData.WCImageURL =
        "";
    newFormData.Status = 1;
    newFormData.IsGemar = newFormData.IsPartyDeco = false;
    newFormData.CategoryOption = null;
    setAddFormData(newFormData);
    setOpenModal(true);
    setSubmitted(false);
    let newWordPressData = { ...wordPressData };
    newWordPressData.source_url = "";
    setWordPressData(newWordPressData);
    //Toastr('Action successfully executed!', 'success');
  };

  const handleEditClick = (values) => {
    let newWordPressData = { ...wordPressData };
    newWordPressData.source_url = "";
    setWordPressData(newWordPressData);
    dispatch(
      subCategoryActions.getSubCategoryById({
        SubCategoryID: values.SubCategoryID,
      })
    );
    setOpenModal(true);
    setSubmitted(false);
  };

  // Edit sub Category
  useEffect(() => {
    if (subCategory && subCategory.SubCategoryID > 0) {
      newFormData.SubCategoryID = subCategory.SubCategoryID;
      newFormData.WCSubCategoryID = subCategory.WCSubCategoryID;
      newFormData.PDWCSubCategoryID = subCategory.PDWCSubCategoryID;
      newFormData.CategoryID = subCategory.CategoryID;
      newFormData.SubCategoryName = subCategory.SubCategoryName;
      newFormData.Description = subCategory.Description;
      newFormData.ImageFile = subCategory.ImageFile;
      newFormData.ImageFilePath = subCategory.ImageFilePath;
      newFormData.ImageBase64 = "";
      newFormData.WCImageURL = subCategory.WCImageURL;
      newFormData.PDWCImageURL = subCategory.PDWCImageURL;
      newFormData.IsGemar = subCategory.IsGemar;
      newFormData.IsPartyDeco = subCategory.IsPartyDeco;
      newFormData.Status = subCategory.Status;
      newFormData.CategoryOption = {
        value: subCategory.CategoryID,
        label: subCategory.CategoryName,
      };
      setAddFormData(newFormData);
    }
  }, [subCategory]);

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const UploadImages = async (e) => {
    const files = e.target.files;
    let file = files[0];
    if (file) {
      const fileType = file["type"];
      const validImageTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!validImageTypes.includes(fileType)) {
        hideLoader();
        Toastr("Invalid file format selected", "warning");
        refImageFormData.current = "";
      } else {
        const MAX_FILE_SIZE = 5120; // 5MB
        const fileSizeKiloBytes = file.size / 1024;

        if (fileSizeKiloBytes > MAX_FILE_SIZE) {
          Toastr("File size is greater than maximum 5MB", "warning");
        } else {
          let base64 = await convertBase64(file);
          let formData = new FormData();
          formData.append("file", file);
          newFormData.ImageBase64 = base64;
          setAddFormData(newFormData);
          refImageFormData.current = formData;
        }
      }
    }
  };

  // Submit data function
  const handleSubmit = (event) => {
    event.preventDefault();

    var error = false;
    if (
      !addFormData.SubCategoryName ||
      (addFormData.IsGemar === false && addFormData.IsPartyDeco === false)
    ) {
      error = true;
    }
    if (newFormData.IsGemar === false && newFormData.IsPartyDeco === false) {
      error = true;
    }
    // if ((newFormData.SubCategoryID > 0 && !newFormData.WCImageURL) || (!newFormData.CategoryID || newFormData.CategoryID === 0) || ((newFormData.SubCategoryID < 1 || !newFormData.SubCategoryID) && !newFormData.ImageBase64)) {
    //     error = true;
    // }
    if (!error) {
      let categoryList = categoryDrpList.filter(
        (d) => d.value === newFormData.CategoryID
      );
      let WCParentId = 0;
      let pdWCParentId = 0;
      let categoryIsGemar = false;
      let categoryIsPartyDeco = false;
      if (categoryList && categoryList[0]) {
        let categoryDetail = categoryList && categoryList[0] && categoryList[0];
        WCParentId = categoryDetail.wcid;
        pdWCParentId = categoryDetail.pdWcid;
        categoryIsGemar = categoryDetail.IsGemar;
        categoryIsPartyDeco = categoryDetail.IsPartyDeco;
      }

      if (
        (newFormData.IsGemar === true &&
          newFormData.IsPartyDeco === false &&
          WCParentId &&
          parseInt(WCParentId) > 0) ||
        (newFormData.IsPartyDeco === true &&
          newFormData.IsGemar === false &&
          pdWCParentId &&
          parseInt(pdWCParentId) > 0) ||
        (newFormData.IsPartyDeco === true &&
          newFormData.IsGemar === true &&
          WCParentId &&
          parseInt(WCParentId) > 0 &&
          pdWCParentId &&
          parseInt(pdWCParentId) > 0)
      ) {
        if (newFormData.SubCategoryID > 0) {
          showLoader();

          if (refImageFormData.current) {
            if (
              newFormData.IsGemar === true &&
              newFormData.IsPartyDeco === true
            ) {
              AddUpdateDataWithImageGemarAndPA(WCParentId, pdWCParentId);
            } else if (newFormData.IsGemar === true) {
              AddUpdateDataWithImageGemar(WCParentId);
            } else if (newFormData.IsPartyDeco === true) {
              AddUpdateDataWithImagePA(pdWCParentId);
            }
          } else {
            let gemar_data = "";
            let PD_data = "";

            if (newFormData.WCImageURL) {
              gemar_data = {
                name: newFormData.SubCategoryName,
                parent: WCParentId,
                description: newFormData.Description,
                image: { src: newFormData.WCImageURL },
              };
            } else {
              gemar_data = {
                name: newFormData.SubCategoryName,
                parent: WCParentId,
                description: newFormData.Description,
                image: null,
              };
            }

            if (newFormData.PDWCImageURL) {
              PD_data = {
                name: newFormData.SubCategoryName,
                parent: pdWCParentId,
                description: newFormData.Description,
                image: { src: newFormData.PDWCImageURL },
              };
            } else {
              PD_data = {
                name: newFormData.SubCategoryName,
                parent: pdWCParentId,
                description: newFormData.Description,
                image: null,
              };
            }

            if (
              newFormData.IsGemar === true &&
              newFormData.IsPartyDeco === true
            ) {
              if (
                newFormData.WCSubCategoryID > 0 &&
                newFormData.PDWCSubCategoryID > 0
              ) {
                UpdateSubCategory_GemarAndPD(gemar_data, PD_data);
              } else if (newFormData.WCSubCategoryID > 0) {
                UpdateSubCategory_UpdateGemarAndAddPD(gemar_data, PD_data);
              } else if (newFormData.PDWCSubCategoryID > 0) {
                UpdateSubCategory_AddGemarAndUpdatePD(gemar_data, PD_data);
              }
            } else if (newFormData.IsGemar === true) {
              UpdateSubCategory_Gemar(gemar_data);
            } else if (newFormData.IsPartyDeco === true) {
              UpdateSubCategory_PD(PD_data);
            }
          }
        } else {
          showLoader();

          if (refImageFormData.current) {
            if (
              newFormData.IsGemar === true &&
              newFormData.IsPartyDeco === true
            ) {
              AddUpdateDataWithImageGemarAndPA(WCParentId, pdWCParentId);
            } else if (newFormData.IsGemar === true) {
              AddUpdateDataWithImageGemar(WCParentId);
            } else if (newFormData.IsPartyDeco === true) {
              AddUpdateDataWithImagePA(pdWCParentId);
            }
          } else {
            let gemar_data = {
              name: newFormData.SubCategoryName,
              parent: WCParentId,
              description: newFormData.Description,
            };

            let PD_data = {
              name: newFormData.SubCategoryName,
              parent: pdWCParentId,
              description: newFormData.Description,
            };

            if (
              newFormData.IsGemar === true &&
              newFormData.IsPartyDeco === true
            ) {
              AddSubCategory_GemarAndPD(gemar_data, PD_data);
            } else if (newFormData.IsGemar === true) {
              AddSubCategory_Gemar(gemar_data);
            } else if (newFormData.IsPartyDeco === true) {
              AddSubCategory_PD(PD_data);
            }
          }
        }
      } else {
        Toastr(
          "Please check category  Gemar and PartyDeco must same sub category",
          "warning"
        );
      }
    } else {
      hideLoader();
      setSubmitted(true);
      Toastr("Please fill in the required missing fields", "warning");
    }
  };

  // Migration fun
  /* const handleMigrationSubmit = (event) => {
    newFormData.PDWCSubCategoryID = 0;
    newFormData.PDWCImageURL = "";
    newFormData.WCSubCategoryID = 0;
    newFormData.WCImageURL = "";
    dispatch(subCategoryActions.saveSubCategory(newFormData));
  }; */

  function AddUpdateDataWithImageGemarAndPA(WCParentId, pdWCParentId) {
    fetch(REACT_APP_WORD_PRESS_REST_API, {
      method: "POST",
      headers: {
        Authorization:
          "Basic " +
          window.btoa(
            REACT_APP_WORD_PRESS_USER_Name + ":" + REACT_APP_WORD_PRESS_PASSWORD
          ),
      },
      body: refImageFormData.current,
    })
      .then((res) => res.json())
      .then((gemarData) => {
        fetch(REACT_APP_PD_WORD_PRESS_REST_API, {
          method: "POST",
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                REACT_APP_PD_WORD_PRESS_USER_Name +
                  ":" +
                  REACT_APP_PD_WORD_PRESS_PASSWORD
              ),
          },
          body: refImageFormData.current,
        })
          .then((res) => res.json())
          .then((PDData) => {
            let gemar_data = {
              name: newFormData.SubCategoryName,
              description: newFormData.Description,
              parent: WCParentId,
              image: {
                src: gemarData.source_url,
              },
            };

            let PD_data = {
              name: newFormData.SubCategoryName,
              description: newFormData.Description,
              parent: pdWCParentId,
              image: {
                src: PDData.source_url,
              },
            };
            if (newFormData.SubCategoryID > 0) {
              if (
                newFormData.WCSubCategoryID > 0 &&
                newFormData.PDWCSubCategoryID > 0
              ) {
                UpdateSubCategory_GemarAndPD(gemar_data, PD_data);
              } else if (newFormData.WCSubCategoryID > 0) {
                UpdateSubCategory_UpdateGemarAndAddPD(gemar_data, PD_data);
              } else if (newFormData.PDWCSubCategoryID > 0) {
                UpdateSubCategory_AddGemarAndUpdatePD(gemar_data, PD_data);
              }
            } else {
              AddSubCategory_GemarAndPD(gemar_data, PD_data);
            }
          })
          .catch((err) => {
            hideLoader();
            console.log(err);
          });
      })
      .catch((err) => {
        hideLoader();
        console.log(err);
      });
  }

  function AddUpdateDataWithImageGemar(WCParentId) {
    fetch(REACT_APP_WORD_PRESS_REST_API, {
      method: "POST",
      headers: {
        Authorization:
          "Basic " +
          window.btoa(
            REACT_APP_WORD_PRESS_USER_Name + ":" + REACT_APP_WORD_PRESS_PASSWORD
          ),
      },
      body: refImageFormData.current,
    })
      .then((res) => res.json())
      .then((gemarData) => {
        let gemar_data = {
          name: newFormData.SubCategoryName,
          description: newFormData.Description,
          parent: WCParentId,
          image: {
            src: gemarData.source_url,
          },
        };
        if (newFormData.SubCategoryID > 0) {
          UpdateSubCategory_Gemar(gemar_data);
        } else {
          AddSubCategory_Gemar(gemar_data);
        }
      })
      .catch((err) => {
        hideLoader();
        console.log(err);
      });
  }

  function AddUpdateDataWithImagePA(pdWCParentId) {
    fetch(REACT_APP_PD_WORD_PRESS_REST_API, {
      method: "POST",
      headers: {
        Authorization:
          "Basic " +
          window.btoa(
            REACT_APP_PD_WORD_PRESS_USER_Name +
              ":" +
              REACT_APP_PD_WORD_PRESS_PASSWORD
          ),
      },
      body: refImageFormData.current,
    })
      .then((res) => res.json())
      .then((PDData) => {
        let PD_data = {
          name: newFormData.SubCategoryName,
          description: newFormData.Description,
          parent: pdWCParentId,
          image: {
            src: PDData.source_url,
          },
        };

        if (newFormData.SubCategoryID > 0) {
          UpdateSubCategory_PD(PD_data);
        } else {
          AddSubCategory_PD(PD_data);
        }
      })
      .catch((err) => {
        hideLoader();
        console.log(err);
      });
  }

  function AddSubCategory_GemarAndPD(gemar_data, PD_data) {
    restApi
      .post("products/categories", gemar_data) // Gemar API

      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCSubCategoryID = response.data.id;
          newFormData.WCImageURL = response.data.image
            ? response.data.image.src
            : "";

          restApi_PD
            .post("products/categories", PD_data) // Party Deco API
            .then((PDResponse) => {
              console.log(PDResponse.data);
              if (
                PDResponse.status === 200 ||
                PDResponse.status === 201 ||
                !PDResponse.statusText
              ) {
                newFormData.PDWCSubCategoryID = PDResponse.data.id;
                newFormData.PDWCImageURL = PDResponse.data.image
                  ? PDResponse.data.image.src
                  : "";
                dispatch(subCategoryActions.saveSubCategory(newFormData));
              } else {
                hideLoader();
                Toastr(PDResponse.statusText, "warning");
              }
            })
            .catch((error) => {
              hideLoader();
              let msg = "";
              if (error.response) {
                if (error.response.data.code === "term_exists") {
                  msg = "Party Deco SubCategory name already exists";
                } else {
                  msg = error.response.data.message;
                }
              } else {
                msg = "rest Api error";
              }
              Toastr(msg, "warning");
              console.log();
            });
        } else {
          hideLoader();
          Toastr(response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = " SubCategory name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "rest Api error";
        }
        Toastr("Gemar : " + msg, "warning");
        console.log();
      });
  }

  function AddSubCategory_Gemar(gemar_data) {
    restApi
      .post("products/categories", gemar_data) // Gemar API
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCSubCategoryID = response.data.id;
          newFormData.WCImageURL = response.data.image
            ? response.data.image.src
            : "";
          if (newFormData.SubCategoryID === 0 || !newFormData.SubCategoryID) {
            newFormData.PDWCSubCategoryID = 0;
            newFormData.PDWCImageURL = "";
          }
          dispatch(subCategoryActions.saveSubCategory(newFormData));
        } else {
          hideLoader();
          Toastr(response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = " SubCategory name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "rest Api error";
        }
        Toastr("Gemar : " + msg, "warning");
        console.log();
      });
  }

  function AddSubCategory_PD(PD_data) {
    restApi_PD
      .post("products/categories", PD_data) // Party Deco API
      .then((PDResponse) => {
        console.log(PDResponse.data);
        if (
          PDResponse.status === 200 ||
          PDResponse.status === 201 ||
          !PDResponse.statusText
        ) {
          newFormData.PDWCSubCategoryID = PDResponse.data.id;
          newFormData.PDWCImageURL = PDResponse.data.image
            ? PDResponse.data.image.src
            : "";
          if (newFormData.SubCategoryID === 0 || !newFormData.SubCategoryID) {
            newFormData.WCSubCategoryID = 0;
            newFormData.WCImageURL = "";
          }

          dispatch(subCategoryActions.saveSubCategory(newFormData));
        } else {
          hideLoader();
          Toastr("Party Deco : " + PDResponse.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "SubCategory name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "rest Api error";
        }
        Toastr("Party Deco : " + msg, "warning");
        console.log();
      });
  }

  function UpdateSubCategory_GemarAndPD(gemar_data, PD_data) {
    restApi
      .put("products/categories/" + newFormData.WCSubCategoryID, gemar_data) // Gemar API
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCSubCategoryID = response.data.id;
          if (response?.data?.image?.src) {
            newFormData.WCImageURL = response.data.image.src;
          } else {
            newFormData.WCImageURL = "";
          }

          restApi_PD
            .put(
              "products/categories/" + newFormData.PDWCSubCategoryID,
              PD_data
            ) // Party Deco API
            .then((PDResponse) => {
              console.log(PDResponse.data);
              if (
                PDResponse.status === 200 ||
                PDResponse.status === 201 ||
                !PDResponse.statusText
              ) {
                newFormData.PDWCSubCategoryID = PDResponse.data.id;
                if (PDResponse?.data?.image?.src) {
                  newFormData.PDWCImageURL = PDResponse.data.image.src;
                } else {
                  newFormData.PDWCImageURL = "";
                }

                // Core WMS API
                dispatch(subCategoryActions.saveSubCategory(newFormData));
              } else {
                hideLoader();
                Toastr("Party Deco :" + PDResponse.statusText, "warning");
              }
            })
            .catch((error) => {
              hideLoader();
              let msg = "";
              if (error.response) {
                if (error?.response?.data?.code === "term_exists") {
                  msg = "Party Deco SubCategory name already exists";
                } else {
                  msg = error.response.data.message;
                }
              } else {
                msg = "Party Deco rest Api error";
              }
              Toastr(msg, "warning");
              console.log();
            });
        } else {
          hideLoader();
          Toastr("Party Deco :" + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Gemar SubCategory name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Gemar rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  function UpdateSubCategory_UpdateGemarAndAddPD(gemar_data, PD_data) {
    restApi
      .put("products/categories/" + newFormData.WCSubCategoryID, gemar_data) // Gemar API
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCSubCategoryID = response.data.id;
          if (response?.data?.image?.src) {
            newFormData.WCImageURL = response.data.image.src;
          } else {
            newFormData.WCImageURL = "";
          }
          // ADD PD
          AddSubCategory_PD(PD_data);
        } else {
          hideLoader();
          Toastr("Gemar :" + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Gemar SubCategory name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Gemar rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }
  function UpdateSubCategory_AddGemarAndUpdatePD(gemar_data, PD_data) {
    restApi_PD
      .put("products/categories/" + newFormData.PDWCSubCategoryID, PD_data) // Party Deco API
      .then((PDResponse) => {
        console.log(PDResponse.data);
        if (
          PDResponse.status === 200 ||
          PDResponse.status === 201 ||
          !PDResponse.statusText
        ) {
          newFormData.PDWCSubCategoryID = PDResponse.data.id;

          if (PDResponse?.data?.image?.src) {
            newFormData.PDWCImageURL = PDResponse.data.image.src;
          }

          //Add Gemar
          AddSubCategory_Gemar(gemar_data);
        } else {
          hideLoader();
          Toastr("Party Deco :" + PDResponse.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Party Deco SubCategory name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Party Deco rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  function UpdateSubCategory_Gemar(gemar_data) {
    restApi
      .put("products/categories/" + newFormData.WCSubCategoryID, gemar_data) // Gemar API
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          newFormData.WCSubCategoryID = response.data.id;
          if (response?.data?.image?.src) {
            newFormData.WCImageURL = response.data.image.src;
          } else {
            newFormData.WCImageURL = "";
          }
          newFormData.PDWCSubCategoryID = 0;
          newFormData.PDWCImageURL = "";
          // Core WMS API
          dispatch(subCategoryActions.saveSubCategory(newFormData));
        } else {
          hideLoader();
          Toastr("Gemar :" + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Gemar SubCategory name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Gemar rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  function UpdateSubCategory_PD(PD_data) {
    restApi_PD
      .put("products/categories/" + newFormData.PDWCSubCategoryID, PD_data) // Party Deco API
      .then((PDResponse) => {
        console.log(PDResponse.data);
        if (
          PDResponse.status === 200 ||
          PDResponse.status === 201 ||
          !PDResponse.statusText
        ) {
          newFormData.PDWCSubCategoryID = PDResponse.data.id;

          if (PDResponse?.data?.image?.src) {
            newFormData.PDWCImageURL = PDResponse.data.image.src;
          }
          newFormData.WCSubCategoryID = 0;
          newFormData.WCImageURL = "";
          // Core WMS API
          dispatch(subCategoryActions.saveSubCategory(newFormData));
        } else {
          hideLoader();
          Toastr("Party Deco :" + PDResponse.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "term_exists") {
            msg = "Party Deco SubCategory name already exists";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "Party Deco rest Api error";
        }
        Toastr(msg, "warning");
        console.log();
      });
  }

  // category Add And Update  handleSubmit //
  useEffect(() => {
    if (subCategoryResponse === 1) {
      hideLoader();
      Toastr("Sub Category Successfully Added", "success");
      dispatch(subCategoryActions.getSubCategoryAll());
      setOpenModal(false);
    } else if (subCategoryResponse === 2) {
      hideLoader();
      Toastr("Sub Category Successfully Updated", "success");
      dispatch(subCategoryActions.getSubCategoryAll());
      setOpenModal(false);
    } else if (subCategoryResponse === -1) {
      hideLoader();
      Toastr("Sub Category name already exists ", "warning");
    }
  }, [subCategoryResponse]);

  const handleDeleteClick = (values) => {
    swal({
      title: "Are you sure, you want to delete this Category?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoader();

        let Param = { DeleteID: values.SubCategoryID, DeleteType: 3 };
        CommonService.CheckMappedItem(Param).then((res) => {
          if (res.data === 1) {
            if (values.IsGemar === true && values.IsPartyDeco === true) {
              restApi
                .delete("products/categories/" + values.WCSubCategoryID, {
                  // Gemar API
                  force: true,
                })
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    // Party Deco API
                    restApi_PD
                      .delete(
                        "products/categories/" + values.PDWCSubCategoryID,
                        {
                          force: true,
                        }
                      )
                      .then((PDResponse) => {
                        if (
                          PDResponse.status === 200 ||
                          PDResponse.status === 201 ||
                          !PDResponse.statusText
                        ) {
                          // Core API
                          dispatch(
                            subCategoryActions.deleteSubCategory({
                              SubCategoryID: values.SubCategoryID,
                              DeletedBy: currentUser.Id,
                            })
                          );
                        } else {
                          Toastr(
                            "Party Deco : " + response.statusText,
                            "warning"
                          );
                          hideLoader();
                        }
                      })
                      .catch((error) => {
                        hideLoader();
                        Toastr(
                          error.response
                            ? error.response.data.message
                            : "rest Api error",
                          "warning"
                        );
                        console.log(error.response && error.response.data);
                      });
                  } else {
                    Toastr("Gemar : " + response.statusText, "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning"
                  );
                  console.log(error.response && error.response.data);
                });
            } else if (values.IsGemar === true) {
              // Gemar API
              restApi
                .delete("products/categories/" + values.WCSubCategoryID, {
                  force: true,
                })
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    // Core API
                    dispatch(
                      subCategoryActions.deleteSubCategory({
                        SubCategoryID: values.SubCategoryID,
                        DeletedBy: currentUser.Id,
                      })
                    );
                  } else {
                    Toastr(response.statusText, "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning"
                  );
                  console.log(error.response && error.response.data);
                });
            } else if (values.IsPartyDeco === true) {
              // Party Deco API
              restApi_PD
                .delete("products/categories/" + values.PDWCSubCategoryID, {
                  force: true,
                })
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    // Core API
                    dispatch(
                      subCategoryActions.deleteSubCategory({
                        SubCategoryID: values.SubCategoryID,
                        DeletedBy: currentUser.Id,
                      })
                    );
                  } else {
                    Toastr(response.statusText, "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning"
                  );
                  console.log(error.response && error.response.data);
                });
            }
          } else {
            Toastr("This SubCategory is already mapped", "warning");
            hideLoader();
          }
        });
      }
    });
  };
  // handleDeleteClick
  useEffect(() => {
    if (deleteSubCategoryResponse === 1) {
      hideLoader();
      Toastr("Successfully Deleted", "success");
      dispatch(subCategoryActions.getSubCategoryAll());
    } else if (deleteSubCategoryResponse === -1) {
      hideLoader();
      Toastr("Error ", "warning");
    } else {
      // hideLoader();
    }
  }, [deleteSubCategoryResponse]);

  const handleClickPDF = () => {
    let title = "Sub Category List";
    const columnStyles = {
      CategoryName: { halign: "left", cellWidth: 40 },
      SubCategoryName: { halign: "left", cellWidth: 40 },
      Description: { halign: "left", cellWidth: 40 },
      CreatedByName: { halign: "left", cellWidth: 40 },
      CreatedDateString: { halign: "left", cellWidth: 30 },
      Woocommerce: { halign: "left", cellWidth: 30 },
      StatusName: { halign: "center", cellWidth: 25 },
    };

    generatePDF(finalTableData, generateColumns, true, title, columnStyles);
  };

  const handleClickExcel = () => {
    let title = "Sub Category";
    let generateExcelColumns = [
      "Category Name",
      "Sub Category Name",
      "Description",
      "Created By",
      "Created Date",
      "Website",
      "Status",
    ];
    let new_subCategoryList =
      finalTableData &&
      finalTableData.map(function (obj) {
        return {
          CategoryName: obj.CategoryName,
          SubCategoryName: obj.SubCategoryName,
          Description: obj.Description,
          CreatedByName: obj.CreatedByName,
          CreatedDate: obj.CreatedDateString,
          Woocommerce: obj.Woocommerce,
          StatusName: obj.StatusName,
        };
      });

    generateXlsx(new_subCategoryList, generateExcelColumns, title);
  };

  const handleClickImageClose = () => {
    newFormData.ImageFilePath =
      newFormData.ImageBase64 =
      newFormData.WCImageURL =
      newFormData.PDWCImageURL =
        "";
    setAddFormData(newFormData);
    inputRef.current.value = null;

    hideLoader();
  };

  return (
    <>
      <PageTitle activeMenu="Sub Categories" motherMenu="Master" />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Sub Category List</h4>
          <div className="float-sm-end">
            {subCategoryList && subCategoryList.length > 0 && (
              <>
                <Button
                  className="me-2"
                  variant="danger btn-rounded"
                  onClick={handleClickPDF}
                >
                  <span className="btn-icon-start text-danger">
                    <i className="fa fa-solid fa-file-pdf"></i>
                    {/* <i className="fa fa-regular fa-file-excel"></i> */}
                  </span>
                  PDF
                </Button>
                <Button
                  className="me-2"
                  variant="secondary btn-rounded"
                  onClick={handleClickExcel}
                >
                  <span className="btn-icon-start text-secondary">
                    {/* <i className="fa fa-solid fa-file-pdf"></i> */}
                    <i className="fa fa-regular fa-file-excel"></i>
                  </span>
                  Excel
                </Button>
              </>
            )}

            <Button
              className="me-2"
              variant="primary btn-rounded"
              onClick={handlePoupClick}
            >
              <span className="btn-icon-start text-primary">
                <i className="fa fa-plus color-info" />
              </span>
              Add
            </Button>
          </div>
        </div>
        <div className="card-body">
          <Table
            columns={columns}
            data={subCategoryList}
            onDataUpdate={handleTableDataUpdate}
          />
        </div>
      </div>

      {/* <!-- Modal --> */}
      <Modal className="fade bd-example-modal-lg" show={isOpenModal} size="lg">
        <Modal.Header>
          <Modal.Title>
            {newFormData.SubCategoryID > 0
              ? "Edit Sub Category"
              : "Add Sub Category"}
          </Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setOpenModal(false)}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6 mb-4">
                <div className="contact-name">
                  <label className="text-black font-w500">
                    {" "}
                    Category<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="CategoryID"
                    value={newFormData.CategoryOption}
                    options={categoryDrpList}
                    onChange={(event) => handleDrpChange(event, "CategoryID")}
                    styles={
                      submitted && !newFormData.CategoryOption ? styles : ""
                    }
                    isDisabled={newFormData.SubCategoryID > 0 ? true : false}
                  />
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  {" "}
                  Sub Category Name <span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${
                      submitted &&
                      !newFormData.SubCategoryName &&
                      "border-danger"
                    }`}
                    autocomplete="off"
                    name="SubCategoryName"
                    required="required"
                    onChange={handleChange}
                    placeholder="Sub Category Name"
                    value={newFormData.SubCategoryName}
                    maxLength={50}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">Description</label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control`}
                    autocomplete="off"
                    name="Description"
                    required="required"
                    onChange={handleChange}
                    placeholder="Description"
                    value={newFormData.Description}
                    maxLength={200}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">Active</label>
                <div>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                      name="Status"
                      checked={newFormData.Status === 1 ? true : false}
                      onChange={(event) => handleCkBoxChange(event, "Status")}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Upload/Add Image (jpeg/jpg/png)
                </label>
                <div className="col-md-9 mb-3">
                  {newFormData.ImageFilePath || newFormData.ImageBase64 ? (
                    <>
                      <Fragment>
                        <div className="card">
                          <div className="card-header">
                            <span className="float-right">
                              {" "}
                              <i
                                onClick={() => handleClickImageClose()}
                                className="fas fa-times productImageClose"
                              ></i>
                            </span>
                          </div>

                          <img
                            style={{ height: "170px" }}
                            className="card-img-top"
                            src={
                              !newFormData.ImageBase64
                                ? REACT_APP_API_IMAGE_URL +
                                  newFormData.ImageFilePath
                                : newFormData.ImageBase64
                            }
                            alt="Card image cap"
                          />
                        </div>
                      </Fragment>
                    </>
                  ) : (
                    <div className="card">
                      {newFormData.ImageFilePath || newFormData.ImageBase64 ? (
                        <img
                          style={{ height: "170px" }}
                          className="card-img-top"
                          src={
                            !newFormData.ImageBase64
                              ? REACT_APP_API_IMAGE_URL +
                                newFormData.ImageFilePath
                              : newFormData.ImageBase64
                          }
                          alt="Card image cap"
                        />
                      ) : (
                        <img
                          style={{ height: "170px" }}
                          className="card-img-top"
                          src={emptyImage}
                          alt="Card image cap"
                        />
                      )}
                    </div>
                  )}
                </div>
                <div className="input-group mb-3">
                  <div className="form-file">
                    <input
                      type="file"
                      ref={inputRef}
                      onChange={(event) => UploadImages(event)}
                      className={`custom-file-input form-control ${
                        submitted &&
                        (wordPressData.source_url
                          ? wordPressData.source_url
                          : newFormData.WCImageURL)
                      }`}
                    />
                  </div>
                  <span className="input-group-text">Upload</span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                {newFormData.SubCategoryID > 0 ? (
                  // Update
                  <>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckGemar"
                      name="IsGemar"
                      checked={addFormData.IsGemar === true}
                      disabled={
                        newFormData.SubCategoryID > 0 &&
                        newFormData.WCSubCategoryID > 0
                      }
                      onChange={(event) => handleChkBoxChangeWooCom(event)}
                    />
                    <label
                      className="form-check-label font-w600"
                      htmlFor="flexSwitchCheckGemar"
                    >
                      Gemar
                    </label>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckPartyDeco"
                        name="IsPartyDeco"
                        checked={addFormData.IsPartyDeco === true}
                        disabled={
                          newFormData.SubCategoryID > 0 &&
                          newFormData.PDWCSubCategoryID > 0
                        }
                        onChange={(event) => handleChkBoxChangeWooCom(event)}
                      />
                      <label
                        className="form-check-label font-w600"
                        htmlFor="flexSwitchCheckPartyDeco"
                      >
                        PartyDeco
                      </label>
                    </div>
                  </>
                ) : (
                  // Add
                  <>
                    <input
                      className={`form-check-input ${
                        submitted &&
                        addFormData.IsGemar === false &&
                        addFormData.IsPartyDeco === false &&
                        "border-danger"
                      }`}
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckGemar"
                      name="IsGemar"
                      checked={addFormData.IsGemar === true}
                      onChange={(event) => handleChkBoxChangeWooCom(event)}
                    />
                    <label
                      className="form-check-label font-w600"
                      htmlFor="flexSwitchCheckGemar"
                    >
                      Gemar
                    </label>
                    <div className="form-check">
                      <input
                        className={`form-check-input ${
                          submitted &&
                          addFormData.IsGemar === false &&
                          addFormData.IsPartyDeco === false &&
                          "border-danger"
                        }`}
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckPartyDeco"
                        name="IsPartyDeco"
                        checked={addFormData.IsPartyDeco === true}
                        onChange={(event) => handleChkBoxChangeWooCom(event)}
                      />
                      <label
                        className="form-check-label font-w600"
                        htmlFor="flexSwitchCheckPartyDeco"
                      >
                        PartyDeco
                      </label>
                    </div>
                  </>
                )}
              </div>
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger light" onClick={() => setOpenModal(false)}>
            Close
          </Button>
          <Button
            variant=""
            onClick={handleSubmit}
            // onClick={handleMigrationSubmit}
            className="btn btn-primary"
          >
            {newFormData.SubCategoryID > 0 ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>
      {loader}
    </>
  );
};

export default SubCategories;
